module.exports = "//static.hsappstatic.net/ecosystem-marketplace-core/static-1.7294/img/storefront-header-blobs.svg"